import React, { useState, useEffect } from "react";
import Loading from "../../../../Common/Components/Loading";
import { GetData } from "./Services";
import { CopyToClipboard } from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import BoxShadow from "../../../../Common/Components/BoxShadow";
import { FiClipboard } from "react-icons/fi";

function Footer({ data }) {
  const initialState = {
    loading: true,
    data: null,
  };
  const [copy, setcopy] = useState({
    copiedInvatecode: false,
    copiedLink: false,
  });
  const [state, setstate] = useState(initialState);
  const Handler = () => {
    setstate({ ...state, loading: true });
    GetData().then(data => {
      setstate({ loading: false, data: data });
    });
  };
  useEffect(() => {
    Handler();
  }, []);

  return (
    <div className="row">
      <div className="col-12">
        <BoxShadow style={{ marginTop: "1.5rem", padding: window.screen.width < 576 ? "5px 10px" : "20px" }}>
          {state.loading ? (
            <Loading col={12} height={300} count={1} />
          ) : (
            <div className=" rounded-5" style={{ backgroundColor: "#fff" }}>
              <div className="col-md-12 py-2 mb-4 align-items-center text-center d-flex justify-content-center">
                <h6 className="card-title-dashboard mb-0" style={{ color: "#000" }}>
                  با دعوت دوستان خود{" "}
                  {state && state.data && state.data.invatescore} امتیاز دریافت
                  کنید
                </h6>

                <img
                  src={window.origin + "/img/voucher.png"}
                  alt=""
                  className="mr-2"
                  style={window.screen.width > 575 ? {
                    width: "50px",
                    height: "50px",
                  }
                    : {
                      width: "40px",
                      height: "40px",
                    }
                  }
                />
              </div>
              <div className="row mb-4 mx-0 justify-content-between align-items-center">
                <h6
                  className="card-title-dashboard mb-0"
                  style={{ color: "#000" }}
                >
                  کد دعوت شما
                </h6>
                <div className="d-flex justify-content-between border p-2 rounded"
                  style={{
                    maxWidth: "300px",
                    width: "100%"
                  }}>
                  <CopyToClipboard
                    text={state.data.invatecode}
                    onCopy={() => {
                      setcopy({
                        copied: true,
                      });
                      toast.success("کد دعوت با موفقیت کپی شد");
                    }}
                  >
                    <FiClipboard size={22} />
                  </CopyToClipboard>
                  <span
                    type="text"
                    dir={"rtl"}
                    className="pl-2"
                    style={{ border: "none" }}
                  >
                    {state.data.invatecode}
                  </span>
                </div>
              </div>

              <div className="row mb-2 mx-0 justify-content-between align-items-center">
                <h6 className="card-title-dashboard mb-0" style={{ color: "#000" }} >
                  دریافت اپلیکیشن
                </h6>
                <div className="icons d-flex flex-wrap flex-row-reverse">
                  <a
                    // href="javascript:void(0)"
                    onClick={() =>
                      toast.success("به زودی در دسترس قرار خواهد گرفت")
                    }
                  >
                    <img
                      src={
                        window.origin + "/assets/icons/DashboardIcons/sib.png"
                      }
                      alt=""
                      className="mr-1 image-dashboard rounded"
                      width={"129px"}
                      height={"38px"}
                      style={{ objectFit: "contain" }}
                    />
                  </a>
                  <a
                    href="http://cafebazaar.ir/app/?id=ir.nikotan&ref=share"
                    target="_blank"
                  >
                    <img
                      src={
                        window.origin +
                        "/assets/icons/DashboardIcons/bazar.png"
                      }
                      alt=""
                      className="mr-1 image-dashboard rounded"
                      width={"129px"}
                      height={"38px"}
                      style={{ objectFit: "contain" }}
                    />
                  </a>
                  <a
                    // href="javascript:void(0)"
                    onClick={() =>
                      toast.success("به زودی در دسترس قرار خواهد گرفت")
                    }
                  >
                    <img
                      src={
                        window.origin + "/assets/icons/DashboardIcons/ios.png"
                      }
                      alt=""
                      className="mr-1 image-dashboard rounded"
                      width={"129px"}
                      height={"38px"}
                      style={{ objectFit: "contain" }}
                    />
                  </a>
                </div>
              </div>
            </div>
          )}
        </BoxShadow>
      </div>
    </div>
  );
}

export default Footer;
